class AppConfiguration {
  constructor(appUtils) {
    'inject';

    this._appUtils = appUtils;
    this._config = {};
  }
  getConfig() {
    return this._config;
  }
  setConfig(...args) {
    let newConfig;
    if (args.length === 1) {
      [newConfig] = args;
    } else if (args.length > 1) {
      newConfig = Object.assign(...[{}, ...args]);
    } else {
      newConfig = {};
    }

    this._config = newConfig;
    return this.getConfig();
  }
  get(setting) {
    let result;
    if (Array.isArray(setting)) {
      result = {};
      setting.forEach((name) => {
        result[name] = this.get(name);
      });
    } else {
      result = this._appUtils.getPropertyWithPath(this.getConfig(), setting, '.');
    }

    return result;
  }
}

export { AppConfiguration };
